import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AccountSuspensionModal from '../Screens/User/AccountSuspensionModal';
import configs from '../../configs';

interface SubscriptionGuardProps {
  children: React.ReactNode;
}

const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({ children }) => {
  // Hooks are always called (rules-of-hooks); the payments flag only affects
  // the render branch below. While payments are off nobody is suspended for
  // non-payment, so the guard becomes a pass-through.
  const [showSuspensionModal, setShowSuspensionModal] = useState(false);
  const userLoginData = useSelector((state: any) => state.data.login.value);
  const isAccountSuspended = configs.paymentsEnabled
    ? (userLoginData?.data?.user_plan?.status == 'suspended' ? true : false)
    : false;
  const location = useLocation();

  useEffect(() => {
    // Show modal when account is suspended
    if (isAccountSuspended) {
      setShowSuspensionModal(true);
    }
  }, [isAccountSuspended]);

  // Payments off: pass through, no suspension handling.
  if (!configs.paymentsEnabled) {
    return <>{children}</>;
  }

  // List of allowed paths for suspended accounts
  const allowedPaths = ['/upgrade', '/add-card', '/suspended'];

  // Check if current path is allowed
  const isAllowedPath = allowedPaths.some(path => location.pathname === path);

  // If account is suspended and not on an allowed path, redirect to suspended page
  if (isAccountSuspended && !isAllowedPath) {
    return <Navigate to="/suspended" />;
  }

  return (
    <>
      {/* Suspension Modal */}
      <AccountSuspensionModal 
        isOpen={showSuspensionModal}
        onClose={() => setShowSuspensionModal(false)}
      />
      {children}
    </>
  );
};

export default SubscriptionGuard;